import { themeAtom } from "../../../shared/atoms";
import { debugLogger } from "../../../shared/services/debug-logger";
import { adminStyles } from "../../styles/admin.styles";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

interface Props {
  title: string;
}

const AdminDebugEmptyPanel = ({ title }: Props) => {
  const theme = useAtomValue(themeAtom);
  debugLogger.verbose(`Render AdminDebugEmptyPanel. Title: ${title}`);

  return (
    <div
      data-test={`admin-debug-empty-${title.toLowerCase().replace(/\s+/g, "-")}`}
      className={twMerge(
        "flex min-h-[320px] items-center justify-center shadow-sm",
        theme.home.tailwind.panelBackground,
      )}
    >
      <div className="text-center">
        <p className={twMerge(adminStyles.heading.sectionTitle, theme.home.tailwind.textDefault)}>{title}</p>
        <p className={twMerge("mt-2 text-sm", theme.uwhcAssistant.text)}>No admin actions configured yet.</p>
      </div>
    </div>
  );
};

export default AdminDebugEmptyPanel;
